import React, { useState, useEffect } from 'react'
import { IoMdClose } from "react-icons/io";
import { formatPrice, formatPricewithdecimal } from '../../../../NumberFormat';
import { withTranslation } from "react-i18next";
import ErrorCodePopup from '../../../../Popups/ErrorCodePopup';

const SilangPopup = (props) => {
  const { onClose, submitResult } = props;
  const [label, setLabel] = useState('');
  const [label1, setLabel1] = useState('');
  const [totalPay, setTotalPay] = useState('');
  const [successResultData, setSuccessResultData] = useState([]);
  const [failedResultData, setFailedResultData] = useState([]);

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupMessage, setPopupMessage] = useState('')
  const gameId = localStorage.getItem("activeGameId");

  console.log("submitResult ==>", submitResult);
  useEffect(() => {
    if (submitResult.processLabel && submitResult.game_name) {
      setLabel('Process Done (' + submitResult.processLabel + ' - ' + submitResult.game_name + ')');
      setLabel1('Period : ' + (submitResult.nextPeriode) + ' - ' + submitResult.game_code);
      setTotalPay(submitResult.totalbayar);
    }

    if (submitResult.datasuccess ) {
      const dataArray = Object.values(submitResult.datasuccess)[0];
      const data = dataArray.map((element, index) => ({
        no: ++index,
        bet: element.bet,
        amount: formatPrice(element.amount),
        kei: element.kei,
        disc: element.disc,
        bayar: formatPrice(element.bayar),
        totalWin: formatPrice(element.totalWin)
      }));
      setSuccessResultData(data);
    }

    if (submitResult.datafailed ) {
      const dataArray = Object.values(submitResult.datafailed)[0];
      const data = dataArray.map((element, index) => ({
        no: ++index,
        bet: element.bet,
        amount: formatPrice(element.amount),
        error_code: element.red,
      }));
      setFailedResultData(data);
    }
  }, []);

  const handlePopupOpen = (redValue) => {
    let message;
    let code = '';
    code = 'code' + redValue;
    let popupMessage = props.t(code);
    setPopupMessage(popupMessage);
    setIsPopupOpen(true);
  };

  const handlePopupClose = () => {
    setIsPopupOpen(false);
    setPopupMessage('');
  };

  return (
    <div className="overlay">
      <div className='overlay_innerDiv' onClick={onClose}></div>
      <div className="bbfs_popup">
        <button className="informasi_popup-close" onClick={onClose}>
        <IoMdClose className="btnclose"/>
        </button>
        <div className="bbfs_popup_titleone">{label}</div>
        <div className='trasaction_popup'>
          {failedResultData.length > 0 && (
            <>
              <div className="bbfs_popup_titletwo">{label1} Success</div>
              <div className="informasi_tble_result statement_tble_result">
                <table >
                  <thead>
                    <tr>
                      <th>{props.t('no.')}</th>
                      <th>{props.t('bet')}</th>
                      <th>{props.t('amount')}</th>
                      <th>{props.t('Error Code')}</th>
                      <th>{props.t('Description')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {failedResultData.map((data, index) => (
                      <tr key={index} className={index % 2 === 0 ? "even-row" : "odd-row"}>
                        <td>{data.no}</td>
                        <td><strike>{data.bet}</strike></td>
                        <td><strike>{formatPricewithdecimal(parseFloat(data.amount.replace(/,/g, '')).toFixed(2))}</strike></td>
                        <td><span className='link' onClick={() => handlePopupOpen(data.error_code)}>Click Here {`(${data.error_code})`}</span></td>
                        <td>
                          <a style={{ color: "red" }}>Removed</a>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}
          {successResultData.length > 0 && (
            <>
              <div className="bbfs_popup_titletwo">{label1} Success</div>
              <div className="informasi_tble_result statement_tble_result">
                <table >
                  <thead>
                    <tr>
                      <th>{props.t('no.')}</th>
                      <th>{props.t('bet')}</th>
                      <th>{props.t('amount')}</th>
                      <th>{props.t('kei')}(%)</th>
                      <th>{props.t('discount')}(%)</th>
                      <th>{props.t('pay')}</th>
                      <th>Total {props.t('win')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {successResultData.map((data, index) => (
                      <tr key={index} className={index % 2 === 0 ? "even-row" : "odd-row"}>
                        <td>{data.no}</td>
                        <td>{data.bet}</td>
                        <td>{formatPricewithdecimal(parseFloat(data.amount.replace(/,/g, '')).toFixed(2))}</td>
                        <td>{data.kei}%</td>
                        <td>{data.disc}%</td>
                        <td>{formatPricewithdecimal(parseFloat(data.bayar.replace(/,/g, '')).toFixed(2))}</td>
                        <td>{formatPricewithdecimal(parseFloat(data.totalWin.replace(/,/g, '')).toFixed(2))}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}
          <div className='bbfs_popup_total'>Total Player Pay : {formatPricewithdecimal(totalPay)}</div>
        </div>
      </div>
      {isPopupOpen &&
        (<ErrorCodePopup onClose={handlePopupClose} message={popupMessage} />)
      }
    </div>
  );
};

export default withTranslation()(SilangPopup);
